var scope_0 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/03ccc4f1a739268e54c89650ed9b7202.js').default;

var scope_1 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2dfdfed60e4446818c536f8434fd657d.js').default;

var scope_2 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/39e0cd3676ae0dadd75d2c84a5dc1379.js').default;

var scope_3 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a37b2d7ba1253cd8ebbf1035e94bf35.js').default;

var scope_4 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4e9a62bfd427122e9f59c982dc246991.js').default;

var scope_5 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/55b1c77835d47ab09da10b0d3e4b8b2c.js').default;

var scope_6 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5dd44cba8e60ea2605bd3b303b4b36ba.js').default;

var scope_7 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/876dd2be7f10670b0cf2c3ce5616cb40.js').default;

var scope_8 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95a96a513b2313a6e7170772441000d2.js').default;

var scope_9 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/98808f8bb8389c56f8695c47a5243c89.js').default;

var scope_10 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9eb0640eda22430871c810e98ea8184d.js').default;

var scope_11 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bec74d92e156b8ba22d8ab5d7de8f1d5.js').default;

var scope_12 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9c41f8168dddddda5ec975097456ff4.js').default;

var scope_13 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dceceec492b95d5d8c5a7e573e2194eb.js').default;

var scope_14 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_15 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e9d64fbecbf95b18ea369b51a74562cd.js').default;

var scope_16 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2c2a1f172df0f10fe2f543640879543.js').default;

var scope_17 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f97f855f2c2e6480034b0aa7951f4bb9.js').default;

var scope_18 = require('/Users/chenxiaole/learnTrain/le-react/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd9746a5195166b6d899a634a9d08b9d.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}